import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ConsentContainer } from './containers';
import { updateBodyClass } from 'src/helpers';
import { CONSENT_URL } from 'src/constants/constants.js';
import { BODY_CLASSES } from 'src/constants/constants';
import Layout from 'src/ui/layout';

class ConsentRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.CONSENT);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.CONSENT);
  }

  render() {
    return (
      <Layout headerName="Consent" isConsentPage={true}>
        <Switch>
          <Route path={CONSENT_URL} render={props => <ConsentContainer key={'consent'} {...props} />} />
        </Switch>
      </Layout>
    );
  }
}

export default ConsentRoot;
